import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useListUser = (
  keyword: string,
  page: number,
  size: number,
) =>
  useQuery(['listUser', keyword, page, size], async () => {
    const res = await api.get('/api/cms/user', {
      params: {
        keyword: keyword,
        page: page,
        size: size,
      },
    });
    return res.data.data;
  });
